import BlobGroupApi from "@/api/blob/blobGroupApi";
import i18n from "@/localization/i18n";

export default {
  namespaced: true,
  states: {},
  mutations: {},
  actions: {
    async addOrUpdate({dispatch}, form) {
      try {
        const response = await BlobGroupApi.addOrUpdate(form);
        dispatch('NOTIFY_MSG', i18n.t('blob.notification.save'), {root: true});
        return Promise.resolve(response.data);
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async fetchById({dispatch}, id) {
      try {
        const response = await BlobGroupApi.fetchById(id);
        return Promise.resolve(response.data);
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async fetch({dispatch}) {
      try {
        const response = await BlobGroupApi.fetch();
        return Promise.resolve(response.data);
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async remove({dispatch}, id) {
      try {
        const response = await BlobGroupApi.remove(id);
        return Promise.resolve(response.data);
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    }
  }
}
